module.exports = __webpack_public_path__ + "img/Boy_030023.dffaa0a9.png";